import Model from '@/store/model';
import User from './user';
import Achievement from './achievement';
import MyResults from './my_results';
import ModelError from '../model_error';
import Statistic from './statistic';
import League from './league';
import ProfileAvatars from './profile_avatars';
import TestAvatars from './test_avatars';
import LanguageProgress from './language_progress';

class UserProfileResponse extends Model {
  map(json) {
    super.map(json);

    if (json.errors !== undefined && json.errors !== null) {
      this.mapArray('errors', json.errors, ModelError);
    }

    if (json.league !== undefined && json.league !== null) {
      this.league = new League();
      this.league.map(json.league);
    }

    if (json.user !== undefined && json.user !== null) {
      this.user = new User();
      this.user.map(json.user);
    }

    if (json.challanger_user !== undefined && json.challanger_user !== null) {
      this.challangerUser = new User();
      this.challangerUser.map(json.challanger_user);
    }

    if (json.friends !== undefined && json.friends !== null) {
      this.mapArray('friends', json.friends, User);
    }

    if (json.my_results !== undefined && json.my_results !== null) {
      this.myResults = new MyResults();
      this.myResults.map(json.my_results);
    }

    if (json.profile_avatars !== undefined && json.profile_avatars !== null) {
      this.mapArray('profileAvatars', json.profile_avatars, ProfileAvatars);
    }

    if (json.test_avatars !== undefined && json.test_avatars !== null) {
      this.mapArray('testAvatars', json.test_avatars, TestAvatars);
    }

    if (json.achievements !== undefined && json.achievements !== null) {
      this.mapArray('achievements', json.achievements, Achievement);
    }

    if (json.statistics !== undefined && json.statistics !== null) {
      this.mapArray('statistics', json.statistics, Statistic);
    }

    if (json.language_progress !== undefined && json.language_progress !== null) {
      this.mapArray('languageProgress', json.language_progress, LanguageProgress);
    }
  }
}
export default UserProfileResponse;
